// extracted by mini-css-extract-plugin
var _1 = "BarLegend__bg--XMybl";
var _2 = "BarLegend__entry--dXF6c";
var _3 = "BarLegend__main--mkzgY fontSize__profileSmall--v0KsO";
var _4 = "BarLegend__star--biiJ9";
var _5 = "BarLegend__starOuter--UJqzJ";
export { _1 as "bg", _2 as "entry", _3 as "main", _4 as "star", _5 as "starOuter" }
